module.exports = __webpack_public_path__ + "static/flags/ZM-98e8f739bf8b5e7fdf368a75fe2933ff.gif";